var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 3.542h-2.709V2.5a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v1.042H7.292V2.5a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v1.042H3.333c-.575 0-1.041.466-1.041 1.041v12.5c0 .575.466 1.042 1.041 1.042h13.334c.575 0 1.041-.467 1.041-1.042v-12.5c0-.575-.466-1.041-1.041-1.041Zm-.209 1.25v1.875H3.542V4.792h12.916ZM3.542 16.875V7.917h12.916v8.958H3.542Zm11.041-5.417h-2.5c-.575 0-1.041.467-1.041 1.042V15c0 .575.466 1.042 1.041 1.042h2.5c.575 0 1.042-.467 1.042-1.042v-2.5c0-.575-.467-1.042-1.042-1.042Zm-.208 3.334h-2.083v-2.084h2.083v2.084Z",
    fill: "current"
  })));
};
export default SvgCalendar;